export const MessageType = {
  Success: "Success",
  Fail: "Fail",
  Erorr: "Error",
};
